module.exports = __webpack_public_path__ + "static/media/promineo-wheel.9b2b53df.svg";